import { Component, OnChanges, Input } from "@angular/core";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";

@Component({
	selector: "app-motorshaft-detail",
	templateUrl: "./motorshaft-detail.component.html",
	styleUrls: ["./motorshaft-detail.component.scss"]
})
export class MotorshaftDetailComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	component: AssemblyConfig.MotorShaft;
	@Input()
	raw: APIResults.RawSinglesResult;

	public spectrumoptions?: Highcharts.Options;
	public errormessage: string;

	constructor(private api: ApiService, private charting: ChartingService) {
	}

	async ngOnChanges() {
		if (this.asset && this.component && this.raw) {
			this.spectrumoptions = undefined;
			this.errormessage = undefined;
			try {
				const result = await this.api.GetMotorShaftDetail(this.asset.asset_id, this.component.id, this.raw.rawid);
				const markers = result.markers.map(marker => {
					return { title: marker.name, axisvalue: marker.value };
				});
				this.spectrumoptions = this.charting.SpectrumDefaults("Spectrum", "Gs", [
					{ type: "line", name: "Spectrum Analysis", data: result.spectrum },
				], false, markers);
			} catch (err) {
				this.errormessage = "Unable to load motor shaft details";
				console.error("Couldn't load motorshaft details");
				console.log(err);
			}
		}
	}
}
